import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filename',
  standalone: false,
})
export class FilenamePipe implements PipeTransform {
  transform(path: string): string {
    if (!path) return '';
    return path.split('/').pop() || path.split('\\').pop() || path;
  }
}
